import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { Icon } from '@powdr/components';
import {
  ThemeProps as Prop, Components,
  toggleCarouselFullscreen,
  Breakpoints,
} from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.CONTENT_CAROUSEL;

export const StyledFullscreenButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  margin: 20px;
  padding: 20px;
  cursor: pointer;
  background-color: ${({ $colorProfile }) => (themeUtil(Prop.BTN_BG, CPNT, $colorProfile))};
  transition: all 0.25s ease;

  .fullscreen-toggle-icon {
    svg {
      transition: all 0.25s ease;
      fill: ${({ $colorProfile }) => (themeUtil(Prop.BTN_TXT, CPNT, $colorProfile))};
      color: ${({ $colorProfile }) => (themeUtil(Prop.BTN_TXT, CPNT, $colorProfile))};
    }
  }


  &:hover, &:focus {
    background-color: ${({ $colorProfile }) => (themeUtil(Prop.BTN_BG_HOVER, CPNT, $colorProfile))};

    .fullscreen-toggle-icon {
      svg {
        transition: all 0.25s ease;
        fill: ${({ $colorProfile }) => (themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile))};
        color: ${({ $colorProfile }) => (themeUtil(Prop.BTN_TXT_HOVER, CPNT, $colorProfile))};
      }
    }
  }

  ${Breakpoints.mobile(css`
    margin: 10px;
    height: 10px;
    width: 10px;

  `)}
`;

export const FullscreenIcon = styled(Icon)``;

export const FullscreenButton = ({
  className = '',
  colorProfile = '',
  componentTheme = null,
  isFullscreen,
  setPsuedoFullscreen,
  parentRef,
}) => (
  <StyledFullscreenButton
    aria-label="Toggle fullscreen carousel"
    className={className}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleCarouselFullscreen(parentRef, setPsuedoFullscreen);
    }}
    onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
    $colorProfile={colorProfile}
    $componentTheme={componentTheme}
  >
    <FullscreenIcon
      className="fullscreen-toggle-icon"
      name={isFullscreen ? 'ui-fullscreen-close' : 'ui-fullscreen-open'}
      width={25}
      height={25}
    />
  </StyledFullscreenButton>
);

FullscreenButton.propTypes = {
  className: PropTypes.string,
  parentRef: PropTypes.shape().isRequired,
  colorProfile: PropTypes.string,
  isFullscreen: PropTypes.bool.isRequired,
  setPsuedoFullscreen: PropTypes.func.isRequired,
  componentTheme: PropTypes.oneOf(Object.values(Components)),
};
